import { animateHeroElement } from './helpers';

export const admissionHeroAnimation = () => {
	animateHeroElement(
		'.admission-left-image',
		{ rotate: -10 },
		{
			rotate: 0,
			x: 34,
			y: 22,
			duration: 1.5,
			ease: 'imageEasing',
		}
	);

	animateHeroElement(
		'.admission-left-square',
		{ rotate: -15 },
		{
			rotate: 0,
			x: 50,
			y: 28,
			duration: 1,
			delay: 0.5,
			ease: 'smoothEasing',
		}
	);

	animateHeroElement(
		'.admission-left-circle',
		{},
		{
			x: 60,
			duration: 1,
			delay: 0.5,
			ease: 'smoothEasing',
		}
	);

	animateHeroElement(
		'.admission-right-image',
		{ rotate: -10 },
		{
			rotate: 0,
			x: -59,
			y: -57,
			duration: 1.5,
			ease: 'imageEasing',
		}
	);

	animateHeroElement(
		'.admission-right-circle',
		{},
		{
			x: -40,
			y: -61,
			duration: 1,
			delay: 0.5,
			ease: 'smoothEasing',
		}
	);
};
